import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-with-checkboxes-list',
  templateUrl: './modal-with-checkboxes-list.component.html',
  standalone: true,
  imports: [TranslateModule, NzCheckboxModule, ReactiveFormsModule],
  styleUrls: ['./modal-with-checkboxes-list.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalWithCheckboxesList implements OnInit {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  dataModal: any;
  selectedCheckbox: any;

  constructor(private modalRef: NzModalRef) {}

  ngOnInit() {
    this.dataModal = this.nzModalData.dataModal;
    this.modelData();
  }

  modelData() {
    this.dataModal.elements = this.dataModal.elements.map((el: any) => ({
      label: el,
      selected: false,
    }));
  }

  protected onCheckboxChange(selectedOption: any): void {
    this.dataModal.elements.forEach((option: { label: any; selected: boolean }) => (option.selected = false));
    if (selectedOption.label !== this.selectedCheckbox) {
      selectedOption.selected = true;
      this.selectedCheckbox = selectedOption.label;
    } else {
      this.selectedCheckbox = null;
    }
  }

  protected onExit(): void {
    this.modalRef.close();
  }

  protected onSave(): void {
    const actionCallback = this.nzModalData.dataModal.actionCallback;
    if (actionCallback) {
      actionCallback(this.selectedCheckbox);
    }
  }
}

